import React from "react";
import { createRoot, Root } from "react-dom/client";
import { Toast } from "./Toast";

class ToastService {
  private root: Root | null = null;
  private container: HTMLDivElement | null = null;

  private show(title: string, variant: "success" | "error", duration = 3000) {
    if (typeof window === "undefined") return;
    this.cleanup();

    this.container = document.createElement("div");
    document.body.appendChild(this.container);

    this.root = createRoot(this.container);

    const handleClose = () => {
      this.cleanup();
    };

    this.root.render(
      <Toast
        title={title}
        variant={variant}
        duration={duration}
        onClose={handleClose}
      />
    );
  }

  showSuccess(message: string, duration = 3000) {
    this.show(message, "success", duration);
  }

  showError(message: string, duration = 3000) {
    this.show(message, "error", duration);
  }

  showWarning(message: string, duration = 3000) {
    this.show(message, "error", duration);
  }

  private cleanup() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }

    if (this.container) {
      document.body.removeChild(this.container);
      this.container = null;
    }
  }
}

export default new ToastService();
